import { Quote, Star } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

const TESTIMONIALS = [
    {
        name: "Renato Lima",
        initial: "RL",
        real: true,
        text: "Excelente profissional! Foi pontual, muito educado e dedicado durante serviço. Deu para perceber o cuidado e o perfeccionismo em cada detalhe, não fazendo nada de qualquer jeito. Os resultados das higienizações do sofá e do colchão ficaram excelente, muito melhor do que eu esperava! Dá para ver que ele realmente preza pela qualidade do serviço.",
    },
    {
        name: "Aline Santos",
        initial: "AS",
        real: true,
        text: "Profissional Muito Educado, Prestativo. Conclusão do trabalho com excelência. Parabéns 👏🏻",
    },
    {
        name: "Telma Dias Fleming de Oliveira",
        initial: "TD",
        real: true,
        text: "Excelente Profissional👏 Entregou o esperado, pontualidade, zeloso! Amei 🥰 minhas cadeiras estavam muito sujas. Agora estão muito impecáveis! Podem contratar! Com toda confiança👏",
    },
];

export const Testimonials = () => (
    <section
        id="depoimentos"
        data-testid="testimonials-section"
        className="bg-white py-24 lg:py-32"
    >
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
                <Reveal>
                    <SectionLabel>Depoimentos</SectionLabel>
                    <h2 className="mt-5 font-display font-bold text-navy tracking-tight text-4xl sm:text-5xl leading-[1.1] max-w-xl">
                        A confiança de quem já{" "}
                        <span className="text-brand">contratou</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.15}>
                    <div className="flex flex-col items-start lg:items-end gap-4">
                        <a
                            data-testid="google-rating-badge"
                            href="https://www.google.com/maps/search/Brand%C3%A3o+Morais+Higieniza%C3%A7%C3%A3o"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group inline-flex items-center gap-3 border-2 border-navy/10 hover:border-brand rounded-full px-5 py-3 transition-colors duration-300"
                        >
                            <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden="true">
                                <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z"/>
                                <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z"/>
                                <path fill="#FBBC05" d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z"/>
                                <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z"/>
                            </svg>
                            <span className="font-display font-extrabold text-navy text-lg leading-none">
                                5.0
                            </span>
                            <span className="flex gap-0.5">
                                {Array.from({ length: 5 }).map((_, s) => (
                                    <Star key={s} className="w-3.5 h-3.5 text-brand" fill="currentColor" />
                                ))}
                            </span>
                            <span className="text-xs font-bold text-navy/50">no Google</span>
                        </a>
                        <p className="text-navy/60 text-base max-w-md leading-relaxed lg:text-right">
                            Avaliações reais de clientes que confiaram na Brandão Morais
                            Higienização.
                        </p>
                    </div>
                </Reveal>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
                {TESTIMONIALS.map((t, i) => (
                    <Reveal key={i} delay={i * 0.1}>
                        <figure
                            data-testid={`testimonial-card-${i}`}
                            className={`h-full rounded-3xl p-8 flex flex-col transition-colors duration-300 ${
                                t.real
                                    ? "border-2 border-brand bg-brand/5"
                                    : "border-2 border-dashed border-navy/15 hover:border-brand"
                            }`}
                        >
                            <Quote className="w-8 h-8 text-brand" strokeWidth={1.5} />
                            <blockquote
                                className={`mt-5 flex-1 text-base leading-relaxed ${
                                    t.real ? "text-navy/80" : "text-navy/50 italic"
                                }`}
                            >
                                “
                                {t.real
                                    ? t.text
                                    : "Depoimento demonstrativo — este texto será substituído pela avaliação real de um cliente da Brandão Morais Higienização."}
                                ”
                            </blockquote>
                            <figcaption className="mt-7 flex items-center gap-4">
                                <span
                                    className={`w-12 h-12 rounded-full flex items-center justify-center font-display font-bold ${
                                        t.real
                                            ? "bg-brand text-white text-sm"
                                            : "bg-navy/5 border border-navy/10 text-navy/40"
                                    }`}
                                >
                                    {t.initial}
                                </span>
                                <div>
                                    <p
                                        className={`font-bold text-sm ${
                                            t.real ? "text-navy" : "text-navy/60"
                                        }`}
                                    >
                                        {t.name}
                                    </p>
                                    <div className="flex gap-0.5 mt-1">
                                        {Array.from({ length: 5 }).map((_, s) => (
                                            <Star
                                                key={s}
                                                className={`w-3.5 h-3.5 ${
                                                    t.real ? "text-brand" : "text-navy/15"
                                                }`}
                                                fill="currentColor"
                                            />
                                        ))}
                                    </div>
                                </div>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <div className="mt-12 text-center">
                    <a
                        data-testid="google-review-button"
                        href="https://www.google.com/maps/search/Brand%C3%A3o+Morais+Higieniza%C3%A7%C3%A3o"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group inline-flex items-center gap-3 bg-navy hover:bg-navy-900 text-white font-bold px-8 py-4 rounded-full transition-colors duration-300"
                    >
                        <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden="true">
                            <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z"/>
                            <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z"/>
                            <path fill="#FBBC05" d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z"/>
                            <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z"/>
                        </svg>
                        Avalie-nos no Google
                        <Star className="w-4 h-4 text-brand transition-transform duration-300 group-hover:scale-125" fill="currentColor" />
                    </a>
                    <p className="mt-4 text-xs text-navy/40">
                        Já foi atendido pela BM? Sua avaliação ajuda outros clientes a confiar.
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);
